<template>
    <div>
        <div class="elasticsearchResource-title">
            <div>Elasticsearch</div>
            <div>
                <Button type="primary" :loading="modal_loading" @click="exportList" v-hasPermission="['resourceConfigurationManagement:aws:reservedInstanceResource:elasticsearch:export']">{{ $t('common.export') }}</Button>
            </div>
        </div>
        <div class="elasticsearchResource-top">
            <elasticsearch-resource-search ref="reservedElasticsearchInstanceSearch"></elasticsearch-resource-search>
        </div>
        <table-elasticsearch-resource></table-elasticsearch-resource>
    </div>
</template>

<script>
    import ElasticsearchResourceSearch from '../elasticsearch/ElasticsearchResourceSearch'
    import TableElasticsearchResource from '../elasticsearch/TableElasticsearchResource'

    export default {
        name: 'ElasticsearchResource',
        components: {
            ElasticsearchResourceSearch,
            TableElasticsearchResource
        },
        data () {
            return {
                modal_loading: false,
                accountIds: [],
                regions: [],
                offeringType: '',
                awsId: '',
                expiration: '',
                state: ''
            }
        },
        methods: {
            //导出
            exportList: function () {
                // 获取子组件数据
                this.awsId = this.$refs.reservedElasticsearchInstanceSearch.awsId;
                this.accountIds = this.$refs.reservedElasticsearchInstanceSearch.accountIds;
                this.regions = this.$refs.reservedElasticsearchInstanceSearch.regions;
                this.offeringType = this.$refs.reservedElasticsearchInstanceSearch.offeringType;
                this.state = this.$refs.reservedElasticsearchInstanceSearch.state;
                this.expiration = this.$refs.reservedElasticsearchInstanceSearch.expiration;

                if (this.accountIds == "" || this.accountIds == null) {
                    this.$Message.warning(this.$t('RAM.common.PleaseSelectAccount'), 5)
                    return;
                }
                if (this.regions == "" || this.regions == null) {
                    this.$Message.warning(this.$t('RAM.common.PleaseSelectRegion'), 5)
                    return;
                }

                this.modal_loading = true
                this.$Message.loading({
                  duration: 0,
                  content: this.$t('common.exporting')
                })
                // 下载Excel 文件
                this.$api.reservedInstance.exportReservedElasticsearchInstances({
                   "initAccountType": 2,
                    "accountId": this.awsId,
                    "accountIds": this.accountIds,
                    "regions": this.regions,
                    "offeringType": this.offeringType,
                    "expiration": this.expiration,
                    "state": this.state
                })
                .then(res => {
                    let fileName = this.$t('RAM.export.riElasticsearch')
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                    }
                    this.modal_loading = false;
                    this.$Message.destroy();
                    this.$Message.success(this.$t('common.exportSuccess'));
                })
            }
        }        
        
    }
</script>

<style scoped>
    .elasticsearchResource-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        overflow: hidden;
        font-weight: 600;
    }
    .elasticsearchResource-title>div:nth-child(1)
    {
            float:left;
    }
    .elasticsearchResource-title>div:nth-child(2)
    {
            float:right;
            margin-top: -6px;
    }
    .elasticsearchResource-top
    {
        width: 100%;
    }    
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/reserved_instance/elasticsearch/ElasticsearchResource.vue